import { get, post, put, deletes } from "@common/http";

/**
 * 根据分页查找TTenantCard
 * @param param
 * @returns {*}
 */
export const getTenantCard = (param) => get("/tenant-card", param);

/**
 * 根据list查找TTenantCard:不分页
 * @param param
 * @returns {*}
 */
export const getTenantCardList = (param) => get("/tenant-card/list", param);

/**
 * 添加TTenantCard
 * @param param
 * @returns {*}
 */
export const postTenantCard = (param) => post("/tenant-card", param);

/**
 * 修改TTenantCard信息
 * @param param
 * @returns {*}
 */
export const putTenantCard = (param) => put("/tenant-card", param);

/**
 * 修改TTenantCard信息---个性次卡
 * @param param
 * @returns {*}
 */
export const postTenantCardgx = (param) => post("/t-tenant-individuality-card/editIndividualityCard", param);

/**
 * 修改TTenantCard信息---个性次卡
 * @param param
 * @returns {*}
 */
export const postTenantCardOnegx = (param) => post("/t-tenant-individuality-card/addIndividualityCard", param);

/**
 * 获取TTenantCard详情
 * @param param
 * @returns {*}
 */
export const getTenantCardId = (id) => get(`/tenant-card/${id}`);

/**
 * 获取TTenantCard详情-个性次卡
 * @param param
 * @returns {*}
 */
export const getTenantCardIdgx = (param) => get(`/t-tenant-individuality-card/getIndividualityCard`, param);

/**
 * 删除TTenantCard信息
 * @param param
 * @returns {*}
 */
export const deleteTenantCardId = (id) => deletes(`/tenant-card/${id}`);

/**
 * 批量修改TTenantCard信息
 * @param param
 * @returns {*}
 */
export const putTenantCardBatch = (param) => put("/tenant-card/batch", param);

/**
 * 批量删除TTenantCard信息
 * @param param
 * @returns {*}
 */
export const deleteTenantCardBatch = (param) => deletes("/tenant-card/batch", param);

/**
 * 查找TTenantCard
 * @param param
 * @returns {*}
 */
export const postTenantCardInfo = (param) => post("/tenant-card/info", param);

//  产品
// /
/**
 * 根据分页查找TTenantProduct
 * @param param
 * @returns {*}
 */
export const getTenantProduct = (param) => get("/tenant-product", param);

export const getTenantProductTree = (param) => get("/tenant-product/tree", param);

/**
 * 根据list查找TTenantCard:不分页
 * @param param
 * @returns {*}
 */
export const getTenantProductList = (param) => get("/tenant-product/list", param);

/**
 * 添加TTenantProduct
 * @param param
 * @returns {*}
 */
export const postTenantProduct = (param) => post("/tenant-product", param);

/**
 * 修改TTenantProduct信息
 * @param param
 * @returns {*}
 */
export const putTenantProduct = (param) => put("/tenant-product", param);

/**
 * 获取TTenantProduct详情
 * @param param
 * @returns {*}
 */
export const getTenantProductId = (id) => get(`/tenant-product/${id}`);

/**
 * 获取TTenantProduct详情
 * @param param
 * @returns {*}
 */
export const getProductPageList = (param) => get(`/tenant-product/getProductPageList`, param);

/**
 * 删除TTenantProduct信息
 * @param param
 * @returns {*}
 */
export const deleteTenantProductId = (id) => deletes(`/tenant-product/${id}`);

/**
 * 批量修改TTenantProduct信息
 * @param param
 * @returns {*}
 */
export const putTenantProductBatch = (param) => put("/tenant-product/batch", param);

/**
 * 批量删除TTenantProduct信息
 * @param param
 * @returns {*}
 */
export const deleteTenantProductBatch = (param) => deletes("/tenant-product/batch", param);

/**
 * 查找TTenantProduct
 * @param param
 * @returns {*}
 */
export const postTenantProductInfo = (param) => post("/tenant-product/info", param);

// 项目
// 获取资金管理 * 项目业绩报表
export const getProjetRentaList = (param) => get(`/statistic/package`, param);
// 获取资金管理 * 项目业绩报表--次卡耗卡数据
export const getConsumptionCardList = (param) => get(`/statistic/packageTimeCard`, param);
// 获取资金管理 * 项目业绩报表--汇总数据
export const getTheTotalList = (param) => get(`/statistic/packageSum`, param);
// 获取商品管理 * 项目列表
export const getGoodPackage = (param) => get(`/tenant-package`, param);

export const getGoodPackageList = (param) => get(`/tenant-package/list`, param);

export const getTenantPackageTree = (param) => get("/tenant-package/tree", param);

// 获取商品管理*项目列表详情
export const getGoodDetails = (id, param) => get(`/tenant-package/${id}`, param);

// 获取个性次卡
export const getPersonalityCardId = (param) => get("/t-tenant-individuality-card/getIndividualityCardId", param);

// 下单新建次卡
export const getNewPersonalityCard = (param) => post("/tenant-card/addForIndividuality", param);

// add项目
export const AddGoodPackage = (param) => post("/tenant-package", param);

// 修改项目列表
export const putGoodPackage = (param) => put("/tenant-package", param);

// 批量项目列表
export const putBatchGoodPackage = (param) => put("/tenant-package/batch", param);

// 删除项目
export const delGoodPackage = (id) => deletes(`/tenant-package/${id}`);

// 批量删除项目
export const delBatchGoodPackage = (param) => deletes("/tenant-package/batch", param);

// 获取商品*项目类别列表（不用分页）增删setting 通用接口
export const getGoodDict = (param) => get("/dict/list", param);

// 检查是否有未支付的订单
export const getCheckOrder = (tenantId, id) => get(`/order/checkOrder?tenantId=${tenantId}&id=${id}`);

// 检索编号 名称是否重复
export const checkCardInfo = (param) => post(`/tenant-card/info`, param);

// 检索编号 名称是否重复
export const checkProductInfo = (param) => post(`/tenant-product/info`, param);

// 同步会员卡
export const syncCard = (param) => post(`/member-base/sync-card`, param);

// 设置库存
export const changeStock = (param) => post(`/productStockFlowRecord/changeStock`, param);

// 获取产品类型
export const getProduceType = (param) => get(`/statistic/product`, param);

// 获取产品总业绩
export const getProductSum = (param) => get(`/statistic/productSum`, param);

// 获取产品出入库单
export const getProductStockStatistics = (param) => get(`/statistic/productStockStatistics`, param);

// 获取产品出入库单
export const getProductOutStockStatistics = (param) => get(`/statistic/productOutStockStatistics`, param);

// 获取产品总出入库单
export const getProductOutSum = (param) => get(`/statistic/productOutSum`, param);

// 获取产品入库单
export const getProductAddStockStatistics = (param) => get(`/statistic/productAddStockStatistics`, param);

// 获取产品总入库单
export const getProductAddSum = (param) => get(`/statistic/productAddSum`, param);

// 批量修改会员散客劳动业绩
export const putBatch = (param) => put(`/t-tenant-package-brokerage-customer-type/batch`, param);

// 查找重复的订单
export const orderRepeat = (param) => get(`/order/leachRepeatSerialNum`, param);

// 获取店铺拉卡拉是否开通信息
export const lakalaPayConfig = (tenantId) => get(`/t-lakala-pay-config/list?TENANT_ID=${tenantId}`);

// @param { payCrashAmount  支付金额   receiptCode  付款码   tenantId  门店id }
export const lakalPayment = (param) => post("/order/userCodePayment", param);

// 支付订单查询接口 查询用户订单是否支付完成
export const changePayOrder = (param) => post("/order/changePayOrder", param);

export const obtainUnmodifiableHandler = (tenantId) => get(`/order/getWithOrderArray?tenantId=${tenantId}`);

export const modifyTheRoyaltyInformationInBatches = (param) => put("/tenant-package/batchCommission", param);

// 获取业绩结算
export const getDepartmentalPerformance = (param) => post(`/order/consume-achievement`, param);

// 添加部门业绩
export const postAddDepartmentalPerformance = (param) => post(`/departmentAchievement`, param);

export const getPackageItem = (param) => get(`/tenant-package/getPackageItem`, param);



// WEBPACK FOOTER //
// ./src/api/goods.js